import { SystemField } from "./system-field";

export class AvailableLang  extends SystemField{
     
    is_defualt?: string;
    lang_code?: string;
    company_id?: string;
    name?: string;
}
